import { Component, Input, Output, EventEmitter, Injectable, OnInit } from '@angular/core';
import { vaultActions } from '@src/store/reducers/vaultReducer';
import { Store } from '@src/store';
import { VaultConnectionService } from '@src/services/VaultConnectionService.service';

@Injectable({ providedIn: 'root' })
export class DBConnectionComponentService {
    public createComponent(template: string): any {
        template = this.fixTemplate(template);
        @Component({ template })
        class CustomComponent implements OnInit {
            public isDisabled = false;
            public isHidden = false;
            public vaultTypes = [{ ID: -1, Name: 'None', Configuration: {}, VaultType: 'None' }];
            public authenticationType = { ID: -1, Name: 'None', Configuration: {}, VaultType: 'None' };
            @Output() public onEditLink = new EventEmitter();
            public connectionTypes = [{ name: 'Direct', id: 0 }, { name: 'CyberArk', id: 1 }];
            public authTypes = [
                { name: 'Windows Authentication', id: 0 },
                { name: 'SQL Server', id: 1 }
            ];
            public vaultConfiguration = {};
            private dataValue: any;
            public component: any;

            public get data() {
                return this.dataValue;
            }

            @Input() public set data(value) {
                const config = value.connectionProperties.vaultConfiguration;
                this.vaultConfiguration = config ? config : {};
                value.lastVisit = 'Properties';
                value.authType = value.connectionProperties.authType
                    ? this.getAuthType(value.connectionProperties.authType)
                    : this.authTypes[1];
                if (!value.connectionProperties.connectionString) {
                    value.connectionProperties.connectionString = '';
                }
                this.dataValue = value;
            }

            constructor(private store: Store, private componentService: VaultConnectionService) {
            }

            public async ngOnInit() {
                this.vaultConfiguration = this.vaultConfiguration ? this.vaultConfiguration : {};
                await this.store.dispatch({ type: vaultActions.GET_VAULTS });
                const vaults = this.store.getState().vaults;
                if (vaults && vaults.vaults) {
                    this.vaultTypes = [...this.vaultTypes, ...vaults.vaults];
                }
                const vaultId = this.data.connectionProperties.vaultId;
                const vaultType = this.vaultTypes.find(item => item.ID === vaultId);
                this.authenticationType = vaultType ? vaultType : this.vaultTypes[0];
                this.configSelected();
            }

            public configSelected() {
                if (this.authenticationType.ID === -1) {
                    delete this.dataValue.connectionProperties.vaultId;
                    delete this.dataValue.connectionProperties.vaultConfiguration;
                } else {
                    this.dataValue.connectionProperties.vaultId = this.authenticationType.ID;
                    this.dataValue.connectionProperties.vaultConfiguration = this.vaultConfiguration;
                    if (this.authenticationType.VaultType === 'AWS') {
                        this.dataValue.connectionProperties.vaultConfiguration.VersionStage = 'AWSCURRENT';
                    } else {
                        delete this.dataValue.connectionProperties.vaultConfiguration.VersionStage;
                    }
                    this.selectConfig();
                }
            }

            private selectConfig() {
                this.component = null;
                this.store.dispatch({
                    type: vaultActions.GET_VAULT_CONNECTION,
                    payload: { vaultId: this.authenticationType.ID }
                }).then((res) => {
                    this.createPage(res);
                });
            }

            public createPage(htmlTemplate) {
                this.component = this.componentService.createComponent(htmlTemplate);
            }

            public setData = (instance: any) => {
                instance.isDisabled = this.isDisabled;
                instance.isHidden = true;
                instance.vaultConfig = this.authenticationType.Configuration ? this.authenticationType.Configuration : {};
                instance.data = { connection: this.vaultConfiguration ? this.vaultConfiguration : {} };
                instance.onEditLink = this.onEditLink;
            }

            public getAuthType(data: any) {
                switch (parseInt(data, 10)) {
                    case 0: return this.authTypes[0];
                    default: return this.authTypes[1];
                    //default: return this.authTypes[2];
                }
            }

        }

        return CustomComponent;
    }

    private fixTemplate(template: string): string {
        if (!template) {
            return template;
        }

        const tagRegex = /<(input|select|textarea)([^>]*?)>/gi;
        return template.replace(tagRegex, (match, _tagName, attributes) => {
            if (attributes.toLowerCase().indexOf('ngmodel') === -1) {
                return match;
            }

            if (attributes.search(/\bname\s*=/i) !== -1) {
                return match;
            }

            if (attributes.search(/standalone\s*:\s*true/i) !== -1) {
                return match;
            }

            const insertEncoded = ' [ngModelOptions]="{standalone: true}"';
            if (match.endsWith('/>')) {
                return match.slice(0, -2) + insertEncoded + '/>';
            } else {
                return match.slice(0, -1) + insertEncoded + '>';
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/db-connection-component.service.ts